var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticStyle:{"width":"100%"},attrs:{"id":_vm.question.label,"type":"number","placeholder":_vm.question.placeholder},on:{"input":function($event){_vm.$emit('input', Number($event.target.value))}}})
}
var staticRenderFns = []

export { render, staticRenderFns }